import React from 'react';
import { getComponentContent } from '../../helpers.js';
const loadingCircles = process.env.REACT_APP_IMAGES_ROOT + 'circles.svg';

const Loading = ({loaded}) => {

  const content = getComponentContent('Loading');

  return (
    <div className="ssc__loading">
      <div className="ssc__loading__content">
        <img src={loadingCircles} alt="loading" />
        <p>{content.text}</p>
      </div>
    </div>
  );

}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js